export const CHAT_LOAD_THREAD_SENDING = 'CHAT_LOAD_THREAD_SENDING';
export const CHAT_LOAD_THREAD_SUCCESS = 'CHAT_LOAD_THREAD_SUCCESS';
export const CHAT_LOAD_THREAD_FAILURE = 'CHAT_LOAD_THREAD_FAILURE';

export const CHAT_SEND_START = 'CHAT_SEND_START';
export const CHAT_THREAD_READY = 'CHAT_THREAD_READY';
export const CHAT_TOKEN = 'CHAT_TOKEN';
export const CHAT_TOOL_START = 'CHAT_TOOL_START';
export const CHAT_TOOL_END = 'CHAT_TOOL_END';
export const CHAT_STREAM_DONE = 'CHAT_STREAM_DONE';
export const CHAT_STREAM_ERROR = 'CHAT_STREAM_ERROR';
export const CHAT_ABORTED = 'CHAT_ABORTED';

export const CHAT_NEW_THREAD = 'CHAT_NEW_THREAD';
export const CHAT_CLEAR = 'CHAT_CLEAR';
export const CHAT_SET_AVAILABILITY = 'CHAT_SET_AVAILABILITY';
